
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCarouselArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.499 4.501a.763.763 0 0 0-.416.116l-.117.09L3.21 11.46a.763.763 0 0 0 0 1.078l6.75 6.75.005.005a.763.763 0 0 0 1.078-1.078l-.005-.005-5.448-5.449H20.25a.762.762 0 1 0 0-1.524H5.59l5.45-5.45.004-.004a.762.762 0 0 0-.545-1.283Z",
  fill: "var(--theme-primary, #810ea9)",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 0.4
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M10.499 4.50134C10.3512 4.49881 10.2068 4.53952 10.083 4.61658L9.96582 4.70642L3.21094 11.4613C3.06821 11.6043 2.98828 11.7983 2.98828 12.0004C2.98838 12.2022 3.06837 12.3956 3.21094 12.5385L9.96094 19.2885L9.96582 19.2943C10.1103 19.4289 10.3017 19.5018 10.499 19.4984C10.6966 19.4949 10.8857 19.4145 11.0254 19.2748C11.1649 19.1351 11.2446 18.9468 11.248 18.7494C11.2515 18.5519 11.1786 18.3607 11.0439 18.2162L11.0391 18.2113L5.59082 12.7621H20.25C20.4521 12.7621 20.6461 12.6823 20.7891 12.5394C20.932 12.3965 21.0126 12.2025 21.0127 12.0004C21.0127 11.7982 20.9319 11.6043 20.7891 11.4613C20.6461 11.3183 20.4522 11.2377 20.25 11.2377H5.59082L11.0391 5.78845L11.0439 5.78357C11.1785 5.63905 11.2515 5.44781 11.248 5.25037C11.2445 5.05299 11.1649 4.86461 11.0254 4.72498C10.8857 4.58527 10.6966 4.50483 10.499 4.50134Z\" \r\nfill=\"var(--theme-primary, #810ea9)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"0.4\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/CarouselArrowLeft.bb2c319d036f03a8c2746ec0801d6dd8.svg"),
        {
          React: SvgCarouselArrowLeft,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      